<template>
  <div class="py-4 px-2 px-lg-4">
    <div v-if="$clinicId">
      <div class>
        <div class="col-span-3">
          <div class="bg-white rounded-2xl">
            <div class="d-none d-md-block padding-24 radius-18">
              <div class="pb-2">
                <!-- {{ jsUcfirst(getDayOfWeek) }},  -->
                <!-- {{$t('home_page.lbl_date')}} {{ getDay }} {{$t('home_page.lbl_month')}}
                {{ getMonth }} {{$t('home_page.lbl_year')}} {{ getYear }}-->
                {{ getDtTop }}
              </div>
              <div class="fs-28 fw-700 txt-grey-900 mb-0">
                {{ $t("home_page.lbl_welcome") }},
                {{ user && user.doctor ? user.doctor.name : "" }}
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div class="row mb-3">
            <div class="col-12 px-3 d-flex align-items-center">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.62003 18.7401C2.65417 18.8678 2.71328 18.9874 2.79396 19.0921C2.87463 19.1968 2.97526 19.2845 3.09003 19.3501L8.29003 22.3501C8.40357 22.4166 8.52912 22.4601 8.65949 22.478C8.78986 22.4959 8.92248 22.4879 9.04976 22.4545C9.17703 22.421 9.29646 22.3628 9.40118 22.2831C9.5059 22.2034 9.59387 22.1038 9.66003 21.9901L12 17.9301L14.34 21.9901C14.4062 22.1038 14.4942 22.2034 14.5989 22.2831C14.7036 22.3628 14.823 22.421 14.9503 22.4545C15.0776 22.4879 15.2102 22.4959 15.3406 22.478C15.4709 22.4601 15.5965 22.4166 15.71 22.3501L20.91 19.3501C21.0248 19.2845 21.1254 19.1968 21.2061 19.0921C21.2868 18.9874 21.3459 18.8678 21.38 18.7401C21.4462 18.4866 21.4103 18.2173 21.28 17.9901L17.28 11.1601C17.7263 10.3425 17.973 9.4311 18 8.50008C18.0024 7.5918 17.7985 6.69483 17.4038 5.8768C17.0091 5.05877 16.4338 4.34104 15.7213 3.77772C15.0088 3.21439 14.1777 2.82018 13.2907 2.62481C12.4036 2.42944 11.4838 2.438 10.6006 2.64985C9.71735 2.8617 8.89374 3.27131 8.19185 3.8478C7.48997 4.42429 6.92812 5.15261 6.54868 5.97784C6.16924 6.80308 5.98211 7.70369 6.0014 8.61177C6.02069 9.51985 6.24589 10.4117 6.66003 11.2201L2.76003 17.9801C2.68744 18.0911 2.63768 18.2155 2.61365 18.346C2.58961 18.4765 2.59178 18.6105 2.62003 18.7401ZM19 18.1201L15.54 20.1201L12.32 14.5001C13.6926 14.4153 14.9932 13.8569 16 12.9201L19 18.1201ZM12 4.50008C13.0609 4.50008 14.0783 4.92151 14.8285 5.67166C15.5786 6.4218 16 7.43922 16 8.50008C16 9.56095 15.5786 10.5784 14.8285 11.3285C14.0783 12.0787 13.0609 12.5001 12 12.5001C10.9392 12.5001 9.92175 12.0787 9.1716 11.3285C8.42145 10.5784 8.00003 9.56095 8.00003 8.50008C8.00003 7.43922 8.42145 6.4218 9.1716 5.67166C9.92175 4.92151 10.9392 4.50008 12 4.50008ZM8.00003 12.9501C8.54295 13.446 9.17378 13.836 9.86003 14.1001L10.84 15.9301L8.42003 20.1201L4.96003 18.1201L8.00003 12.9501Z"
                  fill="black" />
              </svg>
              <p class="fs-18 txt-grey-700 mb-0 ml-2">
                {{ $globalClinic && $globalClinic.name }}
              </p>
            </div>
            <div class="col-md-3 p-3">
              <div class="home-item" @click="goToPath('/doctor/work-schedules')">
                <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.5 21.75C18.7967 21.75 19.0867 21.662 19.3334 21.4972C19.58 21.3324 19.7723 21.0981 19.8858 20.824C19.9994 20.5499 20.0291 20.2483 19.9712 19.9574C19.9133 19.6664 19.7704 19.3991 19.5607 19.1893C19.3509 18.9796 19.0836 18.8367 18.7926 18.7788C18.5017 18.7209 18.2001 18.7506 17.926 18.8642C17.6519 18.9777 17.4176 19.17 17.2528 19.4166C17.088 19.6633 17 19.9533 17 20.25C17 20.6478 17.158 21.0294 17.4393 21.3107C17.7206 21.592 18.1022 21.75 18.5 21.75ZM26 21.75C26.2967 21.75 26.5867 21.662 26.8334 21.4972C27.08 21.3324 27.2723 21.0981 27.3858 20.824C27.4994 20.5499 27.5291 20.2483 27.4712 19.9574C27.4133 19.6664 27.2704 19.3991 27.0607 19.1893C26.8509 18.9796 26.5836 18.8367 26.2926 18.7788C26.0017 18.7209 25.7001 18.7506 25.426 18.8642C25.1519 18.9777 24.9176 19.17 24.7528 19.4166C24.588 19.6633 24.5 19.9533 24.5 20.25C24.5 20.6478 24.658 21.0294 24.9393 21.3107C25.2206 21.592 25.6022 21.75 26 21.75ZM18.5 27.75C18.7967 27.75 19.0867 27.662 19.3334 27.4972C19.58 27.3324 19.7723 27.0981 19.8858 26.824C19.9994 26.5499 20.0291 26.2483 19.9712 25.9574C19.9133 25.6664 19.7704 25.3991 19.5607 25.1893C19.3509 24.9796 19.0836 24.8367 18.7926 24.7788C18.5017 24.7209 18.2001 24.7506 17.926 24.8642C17.6519 24.9777 17.4176 25.17 17.2528 25.4166C17.088 25.6633 17 25.9533 17 26.25C17 26.6478 17.158 27.0294 17.4393 27.3107C17.7206 27.592 18.1022 27.75 18.5 27.75ZM26 27.75C26.2967 27.75 26.5867 27.662 26.8334 27.4972C27.08 27.3324 27.2723 27.0981 27.3858 26.824C27.4994 26.5499 27.5291 26.2483 27.4712 25.9574C27.4133 25.6664 27.2704 25.3991 27.0607 25.1893C26.8509 24.9796 26.5836 24.8367 26.2926 24.7788C26.0017 24.7209 25.7001 24.7506 25.426 24.8642C25.1519 24.9777 24.9176 25.17 24.7528 25.4166C24.588 25.6633 24.5 25.9533 24.5 26.25C24.5 26.6478 24.658 27.0294 24.9393 27.3107C25.2206 27.592 25.6022 27.75 26 27.75ZM11 21.75C11.2967 21.75 11.5867 21.662 11.8334 21.4972C12.08 21.3324 12.2723 21.0981 12.3858 20.824C12.4994 20.5499 12.5291 20.2483 12.4712 19.9574C12.4133 19.6664 12.2704 19.3991 12.0607 19.1893C11.8509 18.9796 11.5836 18.8367 11.2926 18.7788C11.0017 18.7209 10.7001 18.7506 10.426 18.8642C10.1519 18.9777 9.91762 19.17 9.7528 19.4166C9.58797 19.6633 9.5 19.9533 9.5 20.25C9.5 20.6478 9.65804 21.0294 9.93934 21.3107C10.2206 21.592 10.6022 21.75 11 21.75ZM29 6.75H27.5V5.25C27.5 4.85218 27.342 4.47064 27.0607 4.18934C26.7794 3.90804 26.3978 3.75 26 3.75C25.6022 3.75 25.2206 3.90804 24.9393 4.18934C24.658 4.47064 24.5 4.85218 24.5 5.25V6.75H12.5V5.25C12.5 4.85218 12.342 4.47064 12.0607 4.18934C11.7794 3.90804 11.3978 3.75 11 3.75C10.6022 3.75 10.2206 3.90804 9.93934 4.18934C9.65804 4.47064 9.5 4.85218 9.5 5.25V6.75H8C6.80653 6.75 5.66193 7.22411 4.81802 8.06802C3.97411 8.91193 3.5 10.0565 3.5 11.25V29.25C3.5 30.4435 3.97411 31.5881 4.81802 32.432C5.66193 33.2759 6.80653 33.75 8 33.75H29C30.1935 33.75 31.3381 33.2759 32.182 32.432C33.0259 31.5881 33.5 30.4435 33.5 29.25V11.25C33.5 10.0565 33.0259 8.91193 32.182 8.06802C31.3381 7.22411 30.1935 6.75 29 6.75ZM30.5 29.25C30.5 29.6478 30.342 30.0294 30.0607 30.3107C29.7794 30.592 29.3978 30.75 29 30.75H8C7.60218 30.75 7.22064 30.592 6.93934 30.3107C6.65804 30.0294 6.5 29.6478 6.5 29.25V15.75H30.5V29.25ZM30.5 12.75H6.5V11.25C6.5 10.8522 6.65804 10.4706 6.93934 10.1893C7.22064 9.90804 7.60218 9.75 8 9.75H29C29.3978 9.75 29.7794 9.90804 30.0607 10.1893C30.342 10.4706 30.5 10.8522 30.5 11.25V12.75ZM11 27.75C11.2967 27.75 11.5867 27.662 11.8334 27.4972C12.08 27.3324 12.2723 27.0981 12.3858 26.824C12.4994 26.5499 12.5291 26.2483 12.4712 25.9574C12.4133 25.6664 12.2704 25.3991 12.0607 25.1893C11.8509 24.9796 11.5836 24.8367 11.2926 24.7788C11.0017 24.7209 10.7001 24.7506 10.426 24.8642C10.1519 24.9777 9.91762 25.17 9.7528 25.4166C9.58797 25.6633 9.5 25.9533 9.5 26.25C9.5 26.6478 9.65804 27.0294 9.93934 27.3107C10.2206 27.592 10.6022 27.75 11 27.75Z"
                    fill="currentColor" />
                </svg>
                <p class="fs-14 fw-500 mb-0 mt-2">
                  {{ $t("home_page.lbl_schedule") }}
                </p>
              </div>
            </div>
            <div class="col-md-3 p-3">
              <div class="home-item" @click="goToPath('/meeting')">
                <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M32.295 11.475C32.067 11.3433 31.8083 11.274 31.545 11.274C31.2817 11.274 31.023 11.3433 30.795 11.475L25.5 14.085C25.4573 12.9204 24.9644 11.8177 24.125 11.0092C23.2857 10.2006 22.1654 9.74922 21 9.75H7.5C6.30653 9.75 5.16193 10.2241 4.31802 11.068C3.47411 11.9119 3 13.0565 3 14.25V23.25C3 24.4435 3.47411 25.5881 4.31802 26.432C5.16193 27.2759 6.30653 27.75 7.5 27.75H21C22.1654 27.7508 23.2857 27.2994 24.125 26.4908C24.9644 25.6823 25.4573 24.5796 25.5 23.415L30.84 26.085C31.0445 26.1898 31.2703 26.2463 31.5 26.25C31.7808 26.2509 32.0563 26.1729 32.295 26.025C32.5112 25.8899 32.6893 25.7019 32.8127 25.4788C32.936 25.2558 33.0005 25.0049 33 24.75V12.75C33.0005 12.4951 32.936 12.2442 32.8127 12.0212C32.6893 11.7981 32.5112 11.6101 32.295 11.475ZM22.5 23.25C22.5 23.6478 22.342 24.0294 22.0607 24.3107C21.7794 24.592 21.3978 24.75 21 24.75H7.5C7.10218 24.75 6.72064 24.592 6.43934 24.3107C6.15804 24.0294 6 23.6478 6 23.25V14.25C6 13.8522 6.15804 13.4706 6.43934 13.1893C6.72064 12.908 7.10218 12.75 7.5 12.75H21C21.3978 12.75 21.7794 12.908 22.0607 13.1893C22.342 13.4706 22.5 13.8522 22.5 14.25V23.25ZM30 22.32L25.5 20.07V17.43L30 15.18V22.32Z"
                    fill="currentColor" />
                </svg>

                <p class="fs-14 fw-500 mb-0 mt-2">
                  {{ $t("home_page.lbl_org_meeting") }}
                </p>
              </div>
            </div>
            <div class="col-md-3 p-3">
              <div class="home-item" @click="goToPath('/hoi-chan')">
                <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.575 3.76514C16.25 3.76514 14.345 5.65514 14.345 7.99514C14.345 10.3351 16.235 12.2251 18.575 12.2251C20.915 12.2251 22.805 10.3351 22.805 7.99514C22.805 5.65514 20.915 3.76514 18.575 3.76514Z"
                    stroke="currentColor" stroke-width="2" />
                  <path
                    d="M8.07497 21.5552C5.74997 21.5552 3.84497 23.4452 3.84497 25.7852C3.84497 28.1252 5.73497 30.0152 8.07497 30.0152C10.415 30.0152 12.305 28.1252 12.305 25.7852C12.305 23.4452 10.4 21.5552 8.07497 21.5552Z"
                    stroke="currentColor" stroke-width="2" />
                  <path
                    d="M28.9251 21.5552C26.6001 21.5552 24.6951 23.4452 24.6951 25.7852C24.6951 28.1252 26.5851 30.0152 28.9251 30.0152C31.2651 30.0152 33.1551 28.1252 33.1551 25.7852C33.1551 23.4452 31.2651 21.5552 28.9251 21.5552Z"
                    stroke="currentColor" stroke-width="2" />
                  <path
                    d="M22.9473 31.9792C23.7192 31.6785 24.1012 30.809 23.8005 30.0371C23.4998 29.2652 22.6303 28.8832 21.8584 29.1839L22.9473 31.9792ZM15.136 30.9515L15.5386 29.5065L15.5386 29.5065L15.136 30.9515ZM14.7109 29.2364C13.9353 28.9451 13.0705 29.3377 12.7793 30.1132C12.488 30.8888 12.8806 31.7536 13.6562 32.0448L14.7109 29.2364ZM21.8584 29.1839C19.8695 29.9586 17.6504 30.0948 15.5386 29.5065L14.7335 32.3965C17.4857 33.1632 20.3691 32.9836 22.9473 31.9792L21.8584 29.1839ZM15.5386 29.5065C15.2607 29.4291 14.9846 29.3391 14.7109 29.2364L13.6562 32.0448C14.0122 32.1785 14.3716 32.2957 14.7335 32.3965L15.5386 29.5065Z"
                    fill="currentColor" />
                  <path
                    d="M10.3679 10.4131C11.0143 9.89497 11.9584 9.99891 12.4765 10.6453C12.9947 11.2917 12.8907 12.2357 12.2444 12.7539L10.3679 10.4131ZM7.35236 17.6918L8.80501 18.0657L8.80501 18.0657L7.35236 17.6918ZM8.62513 18.9175C8.48959 19.7348 7.71719 20.2875 6.89993 20.1519C6.08266 20.0164 5.53002 19.244 5.66556 18.4267L8.62513 18.9175ZM12.2444 12.7539C10.579 14.0889 9.35144 15.9426 8.80501 18.0657L5.8997 17.3179C6.61182 14.5511 8.20903 12.1438 10.3679 10.4131L12.2444 12.7539ZM8.80501 18.0657C8.73312 18.345 8.67297 18.6291 8.62513 18.9175L5.66556 18.4267C5.72778 18.0515 5.80607 17.6817 5.8997 17.3179L8.80501 18.0657Z"
                    fill="currentColor" />
                  <path
                    d="M26.6321 10.4131C25.9857 9.89497 25.0416 9.99891 24.5235 10.6453C24.0053 11.2917 24.1093 12.2357 24.7556 12.7539L26.6321 10.4131ZM29.6476 17.6918L28.195 18.0657L28.195 18.0657L29.6476 17.6918ZM28.3749 18.9175C28.5104 19.7348 29.2828 20.2875 30.1001 20.1519C30.9173 20.0164 31.47 19.244 31.3344 18.4267L28.3749 18.9175ZM24.7556 12.7539C26.421 14.0889 27.6486 15.9426 28.195 18.0657L31.1003 17.3179C30.3882 14.5511 28.791 12.1438 26.6321 10.4131L24.7556 12.7539ZM28.195 18.0657C28.2669 18.345 28.327 18.6291 28.3749 18.9175L31.3344 18.4267C31.2722 18.0515 31.1939 17.6817 31.1003 17.3179L28.195 18.0657Z"
                    fill="currentColor" />
                </svg>

                <p class="fs-14 fw-500 mb-0 mt-2">
                  {{ $t("home_page.lbl_org_consultation") }}
                </p>
              </div>
            </div>
            <div class="col-md-3 p-3">
              <a class="home-item block" :href="goToChatsLink" target="_blank">
                <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M28.5 12.75H27V8.25C27 7.05653 26.5259 5.91193 25.682 5.06802C24.8381 4.22411 23.6935 3.75 22.5 3.75H7.5C6.30653 3.75 5.16193 4.22411 4.31802 5.06802C3.47411 5.91193 3 7.05653 3 8.25V26.25C3.00148 26.5461 3.09058 26.8352 3.25608 27.0808C3.42158 27.3264 3.65607 27.5175 3.93 27.63C4.10802 27.714 4.30324 27.7551 4.5 27.75C4.69741 27.7511 4.8931 27.7133 5.07586 27.6387C5.25862 27.564 5.42484 27.454 5.565 27.315L9.78 23.085H12V25.245C12 26.4385 12.4741 27.5831 13.318 28.427C14.1619 29.2709 15.3065 29.745 16.5 29.745H26.88L30.435 33.315C30.5752 33.454 30.7414 33.564 30.9241 33.6387C31.1069 33.7133 31.3026 33.7511 31.5 33.75C31.6968 33.7551 31.892 33.714 32.07 33.63C32.3439 33.5175 32.5784 33.3264 32.7439 33.0808C32.9094 32.8352 32.9985 32.5461 33 32.25V17.25C33 16.0565 32.5259 14.9119 31.682 14.068C30.8381 13.2241 29.6935 12.75 28.5 12.75ZM12 17.25V20.085H9.165C8.96759 20.0839 8.7719 20.1217 8.58914 20.1963C8.40638 20.271 8.24016 20.381 8.1 20.52L6 22.635V8.25C6 7.85218 6.15804 7.47064 6.43934 7.18934C6.72064 6.90804 7.10218 6.75 7.5 6.75H22.5C22.8978 6.75 23.2794 6.90804 23.5607 7.18934C23.842 7.47064 24 7.85218 24 8.25V12.75H16.5C15.3065 12.75 14.1619 13.2241 13.318 14.068C12.4741 14.9119 12 16.0565 12 17.25ZM30 28.635L28.5 27.135C28.3611 26.9933 28.1954 26.8805 28.0126 26.8033C27.8298 26.726 27.6335 26.6858 27.435 26.685H16.5C16.1022 26.685 15.7206 26.527 15.4393 26.2457C15.158 25.9644 15 25.5828 15 25.185V17.25C15 16.8522 15.158 16.4706 15.4393 16.1893C15.7206 15.908 16.1022 15.75 16.5 15.75H28.5C28.8978 15.75 29.2794 15.908 29.5607 16.1893C29.842 16.4706 30 16.8522 30 17.25V28.635Z"
                    fill="currentColor" />
                </svg>

                <p class="fs-14 fw-500 mb-0 mt-2">
                  {{ $t("home_page.lbl_org_chat") }}
                </p>
              </a>
            </div>
            <div class="col-md-3 p-3">
              <div class="home-item cursor-not-allowed">
                <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M34.17 16.305C34.0288 16.131 33.8504 15.9908 33.648 15.8948C33.4455 15.7987 33.2241 15.7493 33 15.75H30V14.25C30 13.0566 29.5259 11.912 28.682 11.0681C27.8381 10.2241 26.6935 9.75003 25.5 9.75003H16.08L15.6 8.25003C15.2888 7.36988 14.7116 6.60829 13.9484 6.07077C13.1851 5.53326 12.2735 5.24643 11.34 5.25003H6C4.80653 5.25003 3.66193 5.72414 2.81802 6.56805C1.97411 7.41197 1.5 8.55656 1.5 9.75003V27.75C1.5 28.9435 1.97411 30.0881 2.81802 30.932C3.66193 31.7759 4.80653 32.25 6 32.25H27.6C28.6218 32.2471 29.6122 31.8964 30.4083 31.2557C31.2043 30.6151 31.7586 29.7226 31.98 28.725L34.5 17.58C34.5456 17.3564 34.5396 17.1253 34.4824 16.9044C34.4252 16.6834 34.3184 16.4784 34.17 16.305ZM8.055 28.08C7.9788 28.4184 7.78769 28.7199 7.5142 28.9332C7.24071 29.1466 6.90174 29.2585 6.555 29.25H6C5.60218 29.25 5.22064 29.092 4.93934 28.8107C4.65804 28.5294 4.5 28.1479 4.5 27.75V9.75003C4.5 9.35221 4.65804 8.97068 4.93934 8.68937C5.22064 8.40807 5.60218 8.25003 6 8.25003H11.34C11.6671 8.23296 11.9908 8.32342 12.2617 8.50761C12.5325 8.69179 12.7356 8.95956 12.84 9.27003L13.65 11.73C13.7463 12.0162 13.9266 12.2666 14.1675 12.4485C14.4083 12.6305 14.6985 12.7356 15 12.75H25.5C25.8978 12.75 26.2794 12.9081 26.5607 13.1894C26.842 13.4707 27 13.8522 27 14.25V15.75H12C11.6533 15.7416 11.3143 15.8535 11.0408 16.0668C10.7673 16.2802 10.5762 16.5817 10.5 16.92L8.055 28.08ZM29.055 28.08C28.9788 28.4184 28.7877 28.7199 28.5142 28.9332C28.2407 29.1466 27.9017 29.2585 27.555 29.25H10.815C10.8925 29.0829 10.9479 28.9064 10.98 28.725L13.2 18.75H31.2L29.055 28.08Z"
                    fill="currentColor" />
                </svg>

                <p class="fs-14 fw-500 mb-0 mt-2">
                  {{ $t("home_page.lbl_org_resource") }}
                </p>
              </div>
            </div>
            <div v-if="false" class="col-md-3 p-3">
              <div class="home-item" @click="goToChats()">
                <svg width="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_iconCarrier">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M2 9C2 6.23858 4.23858 4 7 4H17C19.7614 4 22 6.23858 22 9V15C22 17.7614 19.7614 20 17 20H7C4.23858 20 2 17.7614 2 15V9ZM7 6C5.34315 6 4 7.34315 4 9V15C4 16.6569 5.34315 18 7 18H17C18.6569 18 20 16.6569 20 15V9C20 7.34315 18.6569 6 17 6H7Z"
                      fill="currentColor"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6.21913 8.37531C6.56414 7.94404 7.19343 7.87412 7.6247 8.21913L10.1259 10.2201C11.2216 11.0966 12.7784 11.0966 13.8741 10.2201L16.3753 8.21913C16.8066 7.87412 17.4359 7.94404 17.7809 8.37531C18.1259 8.80657 18.056 9.43586 17.6247 9.78087L15.1235 11.7818C13.2974 13.2427 10.7026 13.2427 8.87652 11.7818L6.37531 9.78087C5.94404 9.43586 5.87412 8.80657 6.21913 8.37531Z"
                      fill="currentColor"></path>
                  </g>
                </svg>

                <p class="fs-14 fw-500 mb-0 mt-2">
                  Hỗ trợ bệnh nhân
                </p>
              </div>
            </div>
          </div>
          <div class="row" v-if="$globalClinic && $globalClinic.organization">
            <div class="col-12 px-3 d-flex align-items-center">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.62003 18.7401C2.65417 18.8678 2.71328 18.9874 2.79396 19.0921C2.87463 19.1968 2.97526 19.2845 3.09003 19.3501L8.29003 22.3501C8.40357 22.4166 8.52912 22.4601 8.65949 22.478C8.78986 22.4959 8.92248 22.4879 9.04976 22.4545C9.17703 22.421 9.29646 22.3628 9.40118 22.2831C9.5059 22.2034 9.59387 22.1038 9.66003 21.9901L12 17.9301L14.34 21.9901C14.4062 22.1038 14.4942 22.2034 14.5989 22.2831C14.7036 22.3628 14.823 22.421 14.9503 22.4545C15.0776 22.4879 15.2102 22.4959 15.3406 22.478C15.4709 22.4601 15.5965 22.4166 15.71 22.3501L20.91 19.3501C21.0248 19.2845 21.1254 19.1968 21.2061 19.0921C21.2868 18.9874 21.3459 18.8678 21.38 18.7401C21.4462 18.4866 21.4103 18.2173 21.28 17.9901L17.28 11.1601C17.7263 10.3425 17.973 9.4311 18 8.50008C18.0024 7.5918 17.7985 6.69483 17.4038 5.8768C17.0091 5.05877 16.4338 4.34104 15.7213 3.77772C15.0088 3.21439 14.1777 2.82018 13.2907 2.62481C12.4036 2.42944 11.4838 2.438 10.6006 2.64985C9.71735 2.8617 8.89374 3.27131 8.19185 3.8478C7.48997 4.42429 6.92812 5.15261 6.54868 5.97784C6.16924 6.80308 5.98211 7.70369 6.0014 8.61177C6.02069 9.51985 6.24589 10.4117 6.66003 11.2201L2.76003 17.9801C2.68744 18.0911 2.63768 18.2155 2.61365 18.346C2.58961 18.4765 2.59178 18.6105 2.62003 18.7401ZM19 18.1201L15.54 20.1201L12.32 14.5001C13.6926 14.4153 14.9932 13.8569 16 12.9201L19 18.1201ZM12 4.50008C13.0609 4.50008 14.0783 4.92151 14.8285 5.67166C15.5786 6.4218 16 7.43922 16 8.50008C16 9.56095 15.5786 10.5784 14.8285 11.3285C14.0783 12.0787 13.0609 12.5001 12 12.5001C10.9392 12.5001 9.92175 12.0787 9.1716 11.3285C8.42145 10.5784 8.00003 9.56095 8.00003 8.50008C8.00003 7.43922 8.42145 6.4218 9.1716 5.67166C9.92175 4.92151 10.9392 4.50008 12 4.50008ZM8.00003 12.9501C8.54295 13.446 9.17378 13.836 9.86003 14.1001L10.84 15.9301L8.42003 20.1201L4.96003 18.1201L8.00003 12.9501Z"
                  fill="black" />
              </svg>
              <p class="fs-18 txt-grey-700 mb-0 ml-2">
                {{ $globalClinic.organization.name }}
              </p>
            </div>
            <div class="col-md-3 p-3">
              <div class="home-item" @click="goToPath('/hoi-chan?view=hall')">
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M31.5 15.0002C31.697 15.0003 31.8921 14.9615 32.0741 14.8862C32.2561 14.8108 32.4215 14.7003 32.5608 14.561C32.7001 14.4217 32.8106 14.2563 32.8859 14.0743C32.9613 13.8923 33.0001 13.6972 33 13.5002V9.00024C33.0001 8.6855 32.9011 8.37872 32.7171 8.12341C32.533 7.8681 32.2733 7.67723 31.9746 7.57788L18.4746 3.07788C18.1665 2.97534 17.8335 2.97534 17.5254 3.07788L4.02539 7.57788C3.72674 7.67723 3.46696 7.8681 3.28291 8.12341C3.09885 8.37872 2.99987 8.6855 3 9.00024V13.5002C2.99995 13.6972 3.03871 13.8923 3.11408 14.0743C3.18944 14.2563 3.29993 14.4217 3.43923 14.561C3.57852 14.7003 3.7439 14.8108 3.92591 14.8862C4.10793 14.9615 4.303 15.0003 4.5 15.0002H6V25.7766C5.12511 26.0848 4.36705 26.6562 3.8299 27.4125C3.29275 28.1687 3.00285 29.0727 3 30.0002V33.0002C2.99995 33.1972 3.03871 33.3923 3.11408 33.5743C3.18944 33.7563 3.29993 33.9217 3.43923 34.061C3.57852 34.2003 3.7439 34.3108 3.92591 34.3862C4.10793 34.4615 4.303 34.5003 4.5 34.5002H31.5C31.697 34.5003 31.8921 34.4615 32.0741 34.3862C32.2561 34.3108 32.4215 34.2003 32.5608 34.061C32.7001 33.9217 32.8106 33.7563 32.8859 33.5743C32.9613 33.3923 33.0001 33.1972 33 33.0002V30.0002C32.9971 29.0727 32.7072 28.1687 32.1701 27.4125C31.633 26.6562 30.8749 26.0848 30 25.7766V15.0002H31.5ZM30 31.5002H6V30.0002C6.0004 29.6025 6.15856 29.2212 6.43978 28.94C6.721 28.6588 7.1023 28.5006 7.5 28.5002H28.5C28.8977 28.5006 29.279 28.6588 29.5602 28.94C29.8414 29.2212 29.9996 29.6025 30 30.0002V31.5002ZM9 25.5002V15.0002H12V25.5002H9ZM15 25.5002V15.0002H21V25.5002H15ZM24 25.5002V15.0002H27V25.5002H24ZM6 12.0002V10.0813L18 6.08079L30 10.0813V12.0002H6Z"
                    fill="currentColor" />
                </svg>

                <p class="fs-14 fw-500 mb-0 mt-2">
                  {{ $t("home_page.lbl_ws_hall") }}
                </p>
              </div>
            </div>
            <div class="col-md-3 p-3">
              <div class="home-item cursor-not-allowed">
                <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M28.5 12.75H27V8.25C27 7.05653 26.5259 5.91193 25.682 5.06802C24.8381 4.22411 23.6935 3.75 22.5 3.75H7.5C6.30653 3.75 5.16193 4.22411 4.31802 5.06802C3.47411 5.91193 3 7.05653 3 8.25V26.25C3.00148 26.5461 3.09058 26.8352 3.25608 27.0808C3.42158 27.3264 3.65607 27.5175 3.93 27.63C4.10802 27.714 4.30324 27.7551 4.5 27.75C4.69741 27.7511 4.8931 27.7133 5.07586 27.6387C5.25862 27.564 5.42484 27.454 5.565 27.315L9.78 23.085H12V25.245C12 26.4385 12.4741 27.5831 13.318 28.427C14.1619 29.2709 15.3065 29.745 16.5 29.745H26.88L30.435 33.315C30.5752 33.454 30.7414 33.564 30.9241 33.6387C31.1069 33.7133 31.3026 33.7511 31.5 33.75C31.6968 33.7551 31.892 33.714 32.07 33.63C32.3439 33.5175 32.5784 33.3264 32.7439 33.0808C32.9094 32.8352 32.9985 32.5461 33 32.25V17.25C33 16.0565 32.5259 14.9119 31.682 14.068C30.8381 13.2241 29.6935 12.75 28.5 12.75ZM12 17.25V20.085H9.165C8.96759 20.0839 8.7719 20.1217 8.58914 20.1963C8.40638 20.271 8.24016 20.381 8.1 20.52L6 22.635V8.25C6 7.85218 6.15804 7.47064 6.43934 7.18934C6.72064 6.90804 7.10218 6.75 7.5 6.75H22.5C22.8978 6.75 23.2794 6.90804 23.5607 7.18934C23.842 7.47064 24 7.85218 24 8.25V12.75H16.5C15.3065 12.75 14.1619 13.2241 13.318 14.068C12.4741 14.9119 12 16.0565 12 17.25ZM30 28.635L28.5 27.135C28.3611 26.9933 28.1954 26.8805 28.0126 26.8033C27.8298 26.726 27.6335 26.6858 27.435 26.685H16.5C16.1022 26.685 15.7206 26.527 15.4393 26.2457C15.158 25.9644 15 25.5828 15 25.185V17.25C15 16.8522 15.158 16.4706 15.4393 16.1893C15.7206 15.908 16.1022 15.75 16.5 15.75H28.5C28.8978 15.75 29.2794 15.908 29.5607 16.1893C29.842 16.4706 30 16.8522 30 17.25V28.635Z"
                    fill="currentColor" />
                </svg>

                <p class="fs-14 fw-500 mb-0 mt-2">
                  {{ $t("home_page.lbl_ws_conversation") }}
                </p>
              </div>
            </div>
            <div class="col-md-3 p-3">
              <div class="home-item cursor-not-allowed">
                <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M34.17 16.305C34.0288 16.131 33.8504 15.9908 33.648 15.8948C33.4455 15.7987 33.2241 15.7493 33 15.75H30V14.25C30 13.0566 29.5259 11.912 28.682 11.0681C27.8381 10.2241 26.6935 9.75003 25.5 9.75003H16.08L15.6 8.25003C15.2888 7.36988 14.7116 6.60829 13.9484 6.07077C13.1851 5.53326 12.2735 5.24643 11.34 5.25003H6C4.80653 5.25003 3.66193 5.72414 2.81802 6.56805C1.97411 7.41197 1.5 8.55656 1.5 9.75003V27.75C1.5 28.9435 1.97411 30.0881 2.81802 30.932C3.66193 31.7759 4.80653 32.25 6 32.25H27.6C28.6218 32.2471 29.6122 31.8964 30.4083 31.2557C31.2043 30.6151 31.7586 29.7226 31.98 28.725L34.5 17.58C34.5456 17.3564 34.5396 17.1253 34.4824 16.9044C34.4252 16.6834 34.3184 16.4784 34.17 16.305ZM8.055 28.08C7.9788 28.4184 7.78769 28.7199 7.5142 28.9332C7.24071 29.1466 6.90174 29.2585 6.555 29.25H6C5.60218 29.25 5.22064 29.092 4.93934 28.8107C4.65804 28.5294 4.5 28.1479 4.5 27.75V9.75003C4.5 9.35221 4.65804 8.97068 4.93934 8.68937C5.22064 8.40807 5.60218 8.25003 6 8.25003H11.34C11.6671 8.23296 11.9908 8.32342 12.2617 8.50761C12.5325 8.69179 12.7356 8.95956 12.84 9.27003L13.65 11.73C13.7463 12.0162 13.9266 12.2666 14.1675 12.4485C14.4083 12.6305 14.6985 12.7356 15 12.75H25.5C25.8978 12.75 26.2794 12.9081 26.5607 13.1894C26.842 13.4707 27 13.8522 27 14.25V15.75H12C11.6533 15.7416 11.3143 15.8535 11.0408 16.0668C10.7673 16.2802 10.5762 16.5817 10.5 16.92L8.055 28.08ZM29.055 28.08C28.9788 28.4184 28.7877 28.7199 28.5142 28.9332C28.2407 29.1466 27.9017 29.2585 27.555 29.25H10.815C10.8925 29.0829 10.9479 28.9064 10.98 28.725L13.2 18.75H31.2L29.055 28.08Z"
                    fill="currentColor" />
                </svg>

                <p class="fs-14 fw-500 mb-0 mt-2">
                  {{ $t("home_page.lbl_ws_resource") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!$clinicId && $appMode === 1">
      <JoinClinic></JoinClinic>
    </div>
    <div v-if="$appMode === 2">
      <JoinOrgV2></JoinOrgV2>
    </div>
    <!-- <h1>Hello</h1> -->
    <!-- <g-gantt-chart
    :chart-start="myChartStart"
    :chart-end="myChartEnd"
  >
    <g-gantt-row
      v-for="row in rows"
      :key="row.label"
      :label="row.label"
      :bars="row.bars"
      bar-start="myStart"
      bar-end="myEnd"
    />
    </g-gantt-chart>-->
  </div>
</template>
<script>
import {
  ButtonAdd,
  Chat,
  HealthRecord,
  IconAdd,
  IconCircle
} from '@/components/Icon'
import { GGanttChart, GGanttRow } from 'vue-ganttastic'
import appUtils from '../utils/appUtils'
import JoinClinic from './JoinClinic'
import JoinOrgV2 from './JoinOrgV2'

export default {
  name: 'DoctorDashboard',
  components: {
    GGanttChart,
    GGanttRow,
    JoinClinic,
    JoinOrgV2,
    HealthRecord,
    IconCircle,
    Chat,
    IconAdd,
    ButtonAdd
  },
  data () {
    return {
      filter_stat: 0,
      user: {},
      stats: {},
      loading: false,
      stats_today: {},
      appointments: null,
      total_appointments_today: 0,
      diseases: null,
      clinic_id: null,
      appUtils,
      statisticData: {},
      mdtRooms: {},
      meetRooms: {},
      meetings: [
        {
          title: 'Phòng hội chẩn Khoa',
          time: '8:00 - 8:30',
          timeStart: '8h'
        }
      ],
      dates: {
        start: new Date(),
        end: new Date()
      },
      myChartStart: '2020-03-01 00:00',
      myChartEnd: '2020-03-02 01:00',
      rows: [
        {
          label: 'My row #1',
          bars: [
            {
              myStart: '2020-03-01 12:10',
              myEnd: '2020-03-01 16:35'
            }
          ]
        }
        // {
        //   label: 'My row #2',
        //   bars: [
        //     {
        //       myStart: '2020-03-02 01:00',
        //       myEnd: '2020-03-02 12:00'
        //     },
        //     {
        //       myStart: '2020-03-02 13:00',
        //       myEnd: '2020-03-02 22:00'
        //     }
        //   ]
        // }
      ]
    }
  },
  mounted () {
    let self = this
    self.user = this.$user
    self.clinic = this.$globalClinic
    // self.getStats()
    self.getAppointments()
    self.getStats(true)
    self.getPersonDiseases()
    this.getDoctorHomePage()
    this.getMdtRooms()
    this.getMeetRooms()

    setTimeout(() => {
      this.sendAmplitude(
        this.$t('workspace_setting.lbl_open_workspace')[this.$orgModel],
        {
          'doctor id':
            self.user && self.user.doctor && self.user.doctor.id
              ? self.user.doctor.id
              : '',
          'doctor name': self.user && self.user.name ? self.user.name : '',
          'workspace id': self.clinic && self.clinic.id ? self.clinic.id : '',
          'workspace name':
            self.clinic && self.clinic.name ? self.clinic.name : '',
          timestamp: window.moment(new Date()).format('HH:mm DD-MM-YYYY')
        }
      )
    }, 100)
  },

  computed: {
    doctorRequest () {
      return this.$rf.getRequest('DoctorRequest')
    },

    getDayOfWeek () {
      return window.moment().format('dddd')
    },

    getDay () {
      return window.moment().format('DD')
    },

    getMonth () {
      return window.moment().format('MM')
    },

    getYear () {
      return window.moment().format('YYYY')
    },

    getCurrentDateTime () {
      return this.moment().locale(this.$lang).format('HH:mm - dd, DD MMM YYYY')
    },

    getDtTop () {
      return this.moment().locale(this.$lang).format('HH:mm, DD/MM/YYYY')
    },
    goToChatsLink () {
      const domain = window.location.hostname === 'localhost' ? 'http://localhost:3000' : process.env.VUE_APP_HODO_CHATS
      return `${domain}/redirect.html?token=${appUtils.getLocalToken()}&lang=${this.$lang}`
    },
    goToConversation () {
      const domain = window.location.hostname === 'localhost' ? 'http://localhost:3000' : process.env.VUE_APP_HODO_CHATS
      return `${domain}/redirect.html?token=${appUtils.getLocalToken()}&lang=${this.$lang}`
    }
  },

  watch: {
    $globalOrg (org) {
      if (!this.$globalClinic && org) {
        window.location.href = '/'
      }
    }
  },

  methods: {
    getBtnFilter (stt) {
      let params = [
        { stt: 0, text: 'Hôm nay', type: 'today', greeting_text: 'hôm nay' },
        { stt: 1, text: 'Tuần', type: 'week', greeting_text: 'tuần này' },
        { stt: 2, text: 'Tháng', type: 'month', greeting_text: 'tháng này' },
        { stt: 3, text: 'Quý', type: 'quarter', greeting_text: 'quý này' }
      ]
      return stt >= 0 ? params[stt] : params
    },
    changeFilter (stt) {
      let self = this
      self.filter_stat = stt
      setTimeout(() => {
        self.getStats()
        self.getAppointments()
        self.getPersonDiseases()
      }, 100)
    },
    async getStats (is_today = false) {
      let self = this
      self.loading = true
      let filter = self.getBtnFilter(self.filter_stat)
      let params = {
        type: filter.type
      }
      try {
        let resp = await this.doctorRequest.getHomeStats(params)
        if (is_today) {
          self.stats_today = resp.data
          self.stats = resp.data
        } else {
          self.stats = resp.data
        }
      } catch (e) {
        // statements
        console.log(e)
      } finally {
        self.loading = false
      }
    },
    goToChats () {
      const domain = window.location.hostname === 'localhost' ? 'http://dev.chats.hodo.app' : process.env.VUE_APP_HODO_CHATS
      const routeRaw = `${domain}/redirect.html?token=${appUtils.getLocalToken()}&lang=${this.$lang}`

      console.log(routeRaw)

      if (appUtils.checkIsMobile()) {
        let linkElement = document.createElement('a')
        const linkId = `conversation_id_${appUtils.randomStr(6, true)}`
        linkElement.id = linkId
        linkElement.href = routeRaw
        window.document.body.appendChild(linkElement)

        const linkEl = document.getElementById(linkId)
        linkEl.setAttribute('rel', 'noopener noreferrer')
        !appUtils.checkIsMobile() && linkEl.setAttribute('target', '_blank')
        linkEl.click()
        linkEl.remove()
        return
      }

      window.open(routeRaw, '_blank')
    },
    seeMore (type) {
      if (type === 1) {
        this.$router.push({ path: '/doctor/patient-diseases' })
      } else if (type === 2) {
        this.$router.push({ path: '/circle' })
      } else if (type === 3) {
        this.$router.push({ path: '/#' })
      }
    },
    async getAppointments () {
      this.loading = true
      let params = {
        clinic_id: this.$clinicId ? this.$clinicId : '',
        doctor_id: this.user && this.user.doctor.id,
        statuses: [1, 2, 4, 5]
      }
      try {
        // if (self.filter_stat === 0) {
        //   // params.start_time = self.formatTimeDateAfterSubtractOneHourse(new Date())
        //   params.start_time = self.getDateTimeStartOf('day')
        //   params.end_time = self.getDateTimeEndOf('day')
        // } else if (self.filter_stat === 1) {
        //   params.start_time = self.getDateTimeStartOf('week')
        //   params.end_time = self.getDateTimeEndOf('week')
        // } else if (self.filter_stat === 2) {
        //   params.start_time = self.getDateTimeStartOf('month')
        //   params.end_time = self.getDateTimeEndOf('month')
        // } else if (self.filter_stat === 3) {
        // params.start_time = self.getDateTimeStartOf('quarter')
        // params.end_time = self.getDateTimeEndOf('quarter')
        // }
        params.start_time = this.getDateTime(this.dates.start, '00:00')
        params.end_time = this.getDateTime(this.dates.end, '23:59')
        let resp = await this.doctorRequest.getAppointments(params)
        this.appointments = resp.data.data
        if (this.filter_stat === 0) {
          this.total_appointments_today = resp.data.total
        }
      } catch (e) {
        // statements
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    // getDateTimeStartOf (type) {
    //   return window.moment().startOf(type).format('HH:mm DD-MM-YYYY')
    // },
    // getDateTimeEndOf (type) {
    //   return window.moment().endOf(type).format('HH:mm DD-MM-YYYY')
    // },
    getDateTime (date, time) {
      return time + ' ' + window.moment(date).format('DD-MM-YYYY')
    },
    formatTimeDateAfterSubtractOneHourse (date_time) {
      return window
        .moment(date_time)
        .subtract(12, 'Hours')
        .format('HH:mm DD-MM-YYYY')
    },
    formatTimeDateStartOf (type) {
      return window.moment().startOf(type).format('HH:mm DD-MM-YYYY')
    },
    formatTimeDateEndOf (type) {
      return window.moment().endOf(type).format('HH:mm DD-MM-YYYY')
    },
    async getRequest () {
      let self = this
      self.loading = true
      let params = {
        sort: 'created_at',
        sort_by: 'desc',
        clinic_id: this.$clinicId ? this.$clinicId : ''
      }
      try {
        if (self.filter_stat === 0) {
          params = {
            sort: 'created_at',
            sort_by: 'desc',
            clinic_id: this.$clinicId ? this.$clinicId : '',
            start_time: null,
            end_time: null,
            'type-list': 'new'
          }
        } else if (self.filter_stat === 1) {
          params = {
            sort: 'created_at',
            sort_by: 'desc',
            clinic_id: this.$clinicId ? this.$clinicId : '',
            start_time: self.formatTimeDateStartOf('week'),
            end_time: self.formatTimeDateEndOf('week'),
            'type-list': 'history'
          }
        } else if (self.filter_stat === 2) {
          params = {
            sort: 'created_at',
            sort_by: 'desc',
            clinic_id: this.$clinicId ? this.$clinicId : '',
            start_time: self.formatTimeDateStartOf('month'),
            end_time: self.formatTimeDateEndOf('month'),
            'type-list': 'history'
          }
        } else if (self.filter_stat === 3) {
          params = {
            sort: 'created_at',
            sort_by: 'desc',
            clinic_id: this.$clinicId ? this.$clinicId : '',
            start_time: self.formatTimeDateStartOf('quarter'),
            end_time: self.formatTimeDateEndOf('quarter'),
            'type-list': 'history'
          }
        }
        let resp = await this.doctorRequest.getRequests(params)
        if (resp) {
          self.requests = resp.data
        }
        if (self.filter_stat === 0) {
          self.total_request_today = self.requests.total
        } else {
          self.total_request = self.total_request_today + self.requests.total
        }
      } catch (e) {
        // statements
        console.log(e)
      } finally {
        self.loading = false
      }
    },
    async getPersonDiseases (num) {
      let self = this
      try {
        var params = {
          limit: num || 10,
          sort: 'updated_at',
          sort_by: 'desc',
          is_accepted: 1
        }
        await this.doctorRequest.getPersonDiseases(params).then((res) => {
          self.diseases = res.data
        })
      } catch (e) {
        console.log(e)
      }
    },

    async getDoctorHomePage () {
      this.statisticData = (await this.doctorRequest.getHomePageSummary()).data
    },

    async getMdtRooms () {
      const nowDay = window.moment().format('DD-MM-YYYY')
      this.mdtRooms = (
        await this.doctorRequest.getMdtRooms({ date: nowDay, with_room: true })
      ).data
    },

    async getMeetRooms () {
      const nowDay = window.moment().format('DD-MM-YYYY')
      this.meetRooms = (
        await this.doctorRequest.getMeetRooms({ date: nowDay })
      ).data
    },

    onAddNewAppt () {
      this.$router.push({ path: '/doctor/appointment-create' })
    },

    jsUcfirst (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },

    onChange () {
      this.getAppointments()
    },
    goToPath (path) {
      this.$router.push({ path })
    },
    async joinMeet () {
      if (!this.$globalClinic.meet_room_id) {
        alert(
          // eslint-disable-next-line standard/computed-property-even-spacing
          this.$t('workspace_setting.lbl_meet_workspace_not_exist')[
            this.$orgModel
          ]
        )
        return
      }
      const meeting_id = this.$globalClinic.meet_room_id
      let data = await this.$rf
        .getRequest('DoctorRequest')
        .showMeetRoom(meeting_id)
      if (data.data) {
        let dm = ''
        if (process.env.NODE_ENV === 'development') {
          dm = 'https://dev.meet.hodo.com.vn/#/'
        } else {
          dm = 'https://meet.hodo.com.vn/#/'
        }
        let token = appUtils.getLocalToken()
        let routeData =
          dm + '_app/' + data.data.room?.room_name + '?token=' + token
        window.open(routeData, '_blank')
      }
    }
  }
}
</script>
<style lang="css" scoped>
.padding-24 {
  padding: 24px;
}

.home-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 115px;
  width: 100%;
  background: #fff;
  color: #20419b;
  border: solid 1px #20419b;
  border-radius: 8px;
}

.home-item:hover {
  background: #20419b;
  color: #fff;
  text-decoration: none;
}
</style>
